import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { ProviderDataRepository } from "../domain/ProviderDataRepository";
import { ProviderDataCreditor } from "../domain/ProviderDataCreditor";
import { ProviderDataResume } from "../domain/ProviderDataResume";
import { ProviderSumCredByYearMonth } from "../domain/ProviderSumCredByYearMonth";
import { ProviderSumCred } from "../domain/ProviderSumCred";

export function createApiProviderDataRepository(): ProviderDataRepository {
  return new APIProviderDataRepository();
}

export class APIProviderDataRepository
  extends APIRepository
  implements ProviderDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getTopProviderCreditorsByCompanyUid(companyUid: string, top: number): Promise<ProviderDataCreditor[]> {
    console.log("getTopProviderCreditorsByCompanyUid companyUid: " + companyUid);
    return this.doGet<ProviderDataCreditor[]>("/api/providersdata/creditors/company/" + companyUid.toString() + "/top/" + top.toString());
  }

  getProvidersWithCredByCompany(companyId: string): Promise<ProviderDataCreditor[]> {
    console.log("getProvidersWithCredByCompany companyId: " + companyId);
    return this.doGet<ProviderDataCreditor[]>("/api/providersdata/creditors/company/" + companyId.toString());
  }

  getProvidersWithResumeByCompany(companyId: string): Promise<ProviderDataResume[]>{
    console.log("getProvidersWithResumeByCompany companyId: " + companyId);
    return this.doGet<ProviderDataResume[]>("/api/providersdata/creditors/resume/company/" + companyId.toString());
  }

  getProvidersWithResumeByCompanyAndYear(companyId: string, year: number): Promise<ProviderDataResume[]>{
    console.log("getProvidersWithResumeByCompanyAndYear companyId: " + companyId + " year: " + year); ;
    return this.doGet<ProviderDataResume[]>("/api/providersdata/creditors/resume/company/" + companyId.toString() + "/year/" + year.toString());
  }

  listResumeCredProvidersYearMonth(companyId: string): Promise<ProviderSumCredByYearMonth[]>{
    if (companyId == null || companyId == undefined || companyId == "") {
      throw new Error("companyId is null or undefined");
    } else {
      return this.doGet<ProviderSumCredByYearMonth[]>("/api/providersdata/company/" + companyId.toString() + "/resumeProvidersCredByYearMonth" );
    }
  }

  listResumeCredProviders(companyId: string): Promise<ProviderSumCred[]>{
    if (companyId == null || companyId == undefined || companyId == "") {
      throw new Error("companyId is null or undefined");
    } else {
      return this.doGet<ProviderSumCred[]>("/api/providersdata/company/" + companyId.toString() + "/resumeProvidersCred" );
    }
  }








}
